/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';

@Component({
  selector: 'xrx-toggle-switch-group',
  templateUrl: './xrx-toggle-switch-group.component.html',
  styleUrls: ['./xrx-toggle-switch-group.component.less'],
  standalone: false,
})
export class XrxToggleSwitchGroupComponent implements OnInit {
  @Input() required: boolean;
  @Input() label: string;
  @Input() list: any;
  @Input() labelKey: string;
  @Input() valueKey: string;
  @Input() isMfd = false;
  @Input() hideMargins = false;

  @Output() change = new EventEmitter<any>();

  ngOnInit() {}

  onToggle(event: boolean, item: any) {
    item[this.valueKey] = !item[this.valueKey];
    this.change.emit(item);
  }
}
